import { useQuery } from '@tanstack/react-query';
import { getIndustries, getBusinessGoals } from '@/services/taxonomy';
import { getProducts } from '@/services/products';
import {
  getActiveAnnouncement,
  getHomepageSections,
  getHomepageStats,
  getFeaturedKnowledge,
  getFeaturedWorkflows,
  getTrendingOpportunities,
} from '@/services/homepage';

const STALE_5MIN = 5 * 60 * 1000;
const STALE_2MIN = 2 * 60 * 1000;

export function useAnnouncement() {
  return useQuery({
    queryKey: ['announcement', 'active'],
    queryFn: getActiveAnnouncement,
    staleTime: STALE_2MIN,
  });
}

export function useHomepageSections() {
  return useQuery({
    queryKey: ['homepage', 'sections'],
    queryFn: getHomepageSections,
    staleTime: STALE_5MIN,
  });
}

export function useHomepageIndustries() {
  return useQuery({
    queryKey: ['homepage', 'industries'],
    queryFn: getIndustries,
    staleTime: STALE_5MIN,
  });
}

export function useHomepageGoals() {
  return useQuery({
    queryKey: ['homepage', 'goals'],
    queryFn: getBusinessGoals,
    staleTime: STALE_5MIN,
  });
}

export function useHomepageProducts() {
  return useQuery({
    queryKey: ['homepage', 'products'],
    queryFn: getProducts,
    staleTime: STALE_5MIN,
  });
}

export function useHomepageKnowledge() {
  return useQuery({
    queryKey: ['homepage', 'knowledge'],
    queryFn: getFeaturedKnowledge,
    staleTime: STALE_5MIN,
  });
}

export function useHomepageWorkflows() {
  return useQuery({
    queryKey: ['homepage', 'workflows'],
    queryFn: getFeaturedWorkflows,
    staleTime: STALE_5MIN,
  });
}

export function useTrendingOpportunities() {
  return useQuery({
    queryKey: ['homepage', 'trending'],
    queryFn: getTrendingOpportunities,
    staleTime: STALE_5MIN,
  });
}

export function useHomepageStats() {
  return useQuery({
    queryKey: ['homepage', 'stats'],
    queryFn: getHomepageStats,
    staleTime: STALE_5MIN,
  });
}
